import { Box, SimpleGrid, Text, Heading, VStack, Spacer, useBreakpointValue } from "@chakra-ui/react";
import { useColorModeValue } from "../../../components/ui/color-mode";
import InfoPage from "../services/Info";
import HeroSection from "../services/Hero";
import { LuFlaskConical, LuGlobe, LuShield, LuUsers } from "react-icons/lu";

const stats = [
    { value: "10+", label: "Open-source repositories", icon: LuGlobe },
    { value: "Free", label: "No license fees, ever", icon: LuShield },
    { value: "REST", label: "Public sensor API", icon: LuFlaskConical },
    { value: "Growing", label: "Makers & scientists community", icon: LuUsers },
];

function StatsBar() {
    const bg = useColorModeValue("primary.50", "primary.900");
    const valueColor = useColorModeValue("primary.600", "primary.300");
    const labelColor = useColorModeValue("gray.600", "gray.400");
    const boxWith = useBreakpointValue({ base: "95%", sm: "90%", xl: "60%" });

    return (
        <Box bg={bg} py={10} px={4} width={boxWith} mx="auto" borderRadius="xl" boxShadow="sm">
            <SimpleGrid columns={{ base: 2, md: 4 }} gap={{ base: 4, md: 8 }} maxW="90%" mx="auto">
                {stats.map((stat, i) => (
                    <VStack key={i} gap={1}>
                        <Box as={stat.icon} boxSize={6} color={valueColor} />
                        <Heading fontSize={{ base: "xl", md: "2xl" }} fontWeight="bold" color={valueColor}>
                            {stat.value}
                        </Heading>
                        <Text fontSize="sm" color={labelColor} textAlign="center">
                            {stat.label}
                        </Text>
                    </VStack>
                ))}
            </SimpleGrid>
        </Box>
    );
}

export default function AboutUsContainer() {

    return (
        <Box width="100%" mx="auto">
            <HeroSection />
            {/* <StatsBar /> */}
            <Spacer my={5} />
            <InfoPage />
        </Box>
    );
}
